/**
 * HomeProjects — Mashaariicda aan dhisnay.
 *
 * Clean text cards: logo, name, one-line description, one link. Deliberately
 * no screenshots — proof of real customers reads fine without them, and the
 * page stays light.
 */
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const IMG = (f) => `${process.env.PUBLIC_URL}/images/partners/${f}`;

/* Play Store developer page — publisher "Daato". Lists every published app. */
const PLAY_DEVELOPER_URL = "https://play.google.com/store/apps/dev?id=6246578002703890949";

/* Google Play triangle. Four flat wedges rather than the official gradient —
   reads correctly at small sizes, where a gradient turns to mud. */
function PlayGlyph({ size = 11 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <path d="M3.6 1.8a1 1 0 0 0-.6.9v18.6a1 1 0 0 0 .6.9l9.6-10.2z" fill="#00A0FF" />
      <path d="M3.6 22.2c.3.2.7.2 1.1 0l11.2-6.4-2.7-2.8z" fill="#FF3A44" />
      <path d="M4.7 1.8c-.4-.2-.8-.2-1.1 0l9.6 10.2 2.7-2.8z" fill="#00C853" />
      <path d="M15.9 8.9l-2.7 3.1 2.7 2.8 3.5-2a1.3 1.3 0 0 0 0-2.2z" fill="#FFBC00" />
    </svg>
  );
}

const projects = [
  {
    name: "Zaara Natural",
    description: "Suuq online ah oo lagu iibiyo badeecada dabiiciga ah",
    logo: IMG("zaaranatural.png"),
    url: "https://play.google.com/store/apps/details?id=so.daato.zaaranatural",
    tag: "App",
  },
  {
    name: "eGanacsi",
    description: "App-ka suuq geynta iyo iibinta badeecada online",
    logo: IMG("eganacsi.png"),
    url: "https://play.google.com/store/apps/details?id=com.ganacsihub.eganacsi",
    tag: "App",
  },
  {
    name: "Banadir Online",
    description: "Suuqa online ee Banadir",
    logo: IMG("banadironline.png"),
    url: "https://play.google.com/store/apps/details?id=com.ganacsihub.banadironline",
    tag: "App",
  },
  {
    name: "Kalkaal Market",
    description: "App-ka suuqa Kalkaal",
    logo: IMG("kalkaal.jpeg"),
    url: "https://play.google.com/store/apps/details?id=com.ganacsihub.kalkaalmarket",
    tag: "App",
  },
  {
    name: "Doorso Market",
    description: "Suuqa online ee Doorso",
    logo: IMG("doorsomarket.png"),
    url: "https://play.google.com/store/apps/details?id=com.ganacsihub.doorsomarket",
    tag: "App",
  },
  {
    name: "Shidan",
    description: "Suuq online oo alaab guri iyo shaqsi",
    logo: IMG("shidan.png"),
    url: "https://play.google.com/store/apps/details?id=so.daato.shidan",
    tag: "App",
  },
  {
    name: "Warsame Medical Center",
    description: "Daawooyinka iyo adeegyada caafimaadka",
    logo: IMG("warsamemedical.png"),
    url: "https://play.google.com/store/apps/details?id=com.ganacsihub.warsamemedicalcenter",
    tag: "App",
  },
  {
    name: "Haybad Mall",
    description: "Iibso alaab iyo xirmooyin internet ah — hal app",
    logo: IMG("haybadmall.png"),
    url: "https://play.google.com/store/apps/details?id=com.ganacsihub.haybadmall",
    tag: "E-commerce + Data",
  },
  {
    name: "Al-Islaam Data",
    description: "Xirmooyinka internetka Hormuud, si fudud u iibso",
    logo: IMG("alislaam.webp"),
    url: "https://play.google.com/store/apps/details?id=so.daato.alislaamdata",
    tag: "Data",
  },
  {
    name: "Qamar Data",
    description: "Xirmooyin internet ah oo raqiis ah, isla markiiba la geeyo",
    logo: IMG("qamar.webp"),
    url: "https://play.google.com/store/apps/details?id=so.daato.qamar",
    tag: "Data",
  },
  {
    name: "GanacsiHub SMS",
    description: "SMS-ka lacag-bixinta wuu akhriyaa oo dalabka si otomaatig ah u xaqiijiyaa",
    logo: `${process.env.PUBLIC_URL}/images/logos/logo-mark.png`,
    url: "https://play.google.com/store/apps/details?id=com.ganacsihub.sms",
    tag: "Tool",
  },
  {
    name: "Maareye",
    description: "Si otomaatig ah ugu diiwaan geli lacagta SMS-ka mobile-ka",
    logo: IMG("maareye.png"),
    url: "https://play.google.com/store/apps/details?id=com.maareye.app",
    tag: "SaaS",
  },
  {
    name: "Koor",
    description: "La soco lacagtaada oo iibso xirmooyin internet ah",
    logo: IMG("koor.png"),
    url: "https://koorapp.app/",
    tag: "App",
  },
  {
    name: "SomQuiz",
    description: "Nidaam imtixaan online ah — ilaalin, buundo otomaatig ah iyo falanqayn",
    logo: IMG("somquiz.png"),
    // Mark sits on a white field — contain so the Q isn't cropped.
    contain: true,
    // Currently served from sompey.so; moving to somquiz.com — swap when the
    // domain cuts over.
    url: "https://sompey.so/",
    tag: "Platform",
  },
  {
    name: "Ossob Coffee",
    description: "Dukaan qaxwo online ah — dalbo oo albaabkaaga lagu keeno",
    logo: IMG("ossobcoffee.webp"),
    // Mark sits on a white field — contain so the crown isn't cropped.
    contain: true,
    url: "https://play.google.com/store/apps/details?id=com.ossob.ossobcoffee",
    tag: "iOS & Android",
  },
  {
    name: "HelGuri",
    description: "Raadi guri ama apartment Soomaaliya — goobta, qiimaha iyo nooca",
    logo: IMG("helguri.webp"),
    url: "https://play.google.com/store/apps/details?id=com.hel.guri",
    tag: "iOS & Android",
  },
  {
    name: "Dawrah",
    description: "Raadraaca xilliga dumarka iyo hage Islaami oo ku saabsan taharada",
    logo: IMG("dawrah.jpg"),
    // Mark sits on a white field — contain so the crescent isn't cropped.
    contain: true,
    url: "https://play.google.com/store/search?q=dawrah&c=apps",
    tag: "iOS & Android",
  },
  {
    name: "Hage App",
    description: "App Islaami ah — salaad, Quran, adkaar iyo caado maalinle ah",
    logo: IMG("hage.png"),
    // habit.ganacsihub.com is the API/admin host, not a public page.
    url: null,
    tag: "App",
  },
  {
    name: "Habitat Foundation",
    description: "Nidaam ololeyaal iyo deeq-bixin online ah",
    logo: IMG("habitat.png"),
    // Brand mark on a white field rather than an app icon — contain it so the
    // circular artwork isn't cropped by the tile.
    contain: true,
    url: "https://habitatfoundation.so/campaigns",
    tag: "Website",
  },
  {
    name: "Tinex Auto Components",
    description: "Dukaan e-commerce ah oo Kenya ku yaal — qalabka baabuurta",
    logo: IMG("tinex.jpeg"),
    // No public URL — renders as a plain card rather than a link.
    url: null,
    tag: "E-commerce",
  },
];

/** Fallback mark when a project has no logo file — first letter on brand ink. */
function Monogram({ name }) {
  return (
    <span
      className="flex h-12 w-12 items-center justify-center font-heading text-lg font-black text-white"
      style={{ background: "var(--brand)", borderRadius: "var(--radius-md)" }}
    >
      {name.charAt(0)}
    </span>
  );
}

function ProjectCard({ project, index }) {
  // Projects without a public URL render as a plain card, not a dead link.
  const isLink = Boolean(project.url);
  const Wrapper = isLink ? motion.a : motion.div;
  const linkProps = isLink
    ? { href: project.url, target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <Wrapper
      {...linkProps}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.4, delay: (index % 3) * 0.06 }}
      className="group flex h-full flex-col p-6 transition-all duration-300 hover:-translate-y-1"
      style={{
        background: "var(--bg-card)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-card)",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "var(--shadow-card-hover)")}
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "var(--shadow-card)")}
    >
      <div className="flex items-start justify-between gap-3">
        {project.logo ? (
          <img
            src={project.logo}
            alt=""
            loading="lazy"
            className={`h-12 w-12 ${project.contain ? "object-contain p-1.5" : "object-cover"}`}
            style={{
              borderRadius: "var(--radius-md)",
              border: "1px solid var(--border)",
              background: project.contain ? "#ffffff" : undefined,
            }}
          />
        ) : (
          <Monogram name={project.name} />
        )}

        <span
          className="px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider"
          style={{ background: "var(--badge-bg)", color: "var(--text-muted)", borderRadius: 999 }}
        >
          {project.tag}
        </span>
      </div>

      <h3 className="font-heading mt-5 text-base font-bold text-navy">{project.name}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed" style={{ color: "var(--text-muted)" }}>
        {project.description}
      </p>

      {isLink ? (
        <span
          className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold transition-colors duration-200"
          style={{ color: "var(--accent)" }}
        >
          Booqo
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      ) : (
        <span className="mt-5 text-sm font-medium" style={{ color: "var(--text-muted)" }}>
          Mashruuc gaar ah
        </span>
      )}
    </Wrapper>
  );
}

/** Same card shape and colour as a project card — only the Play glyph and the
    accent link mark it as the way out to the full catalogue. */
function SeeAllCard({ index }) {
  return (
    <motion.a
      href={PLAY_DEVELOPER_URL}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.4, delay: (index % 3) * 0.06 }}
      className="group flex h-full flex-col p-6 transition-all duration-300 hover:-translate-y-1"
      style={{
        background: "var(--bg-card)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-card)",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "var(--shadow-card-hover)")}
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "var(--shadow-card)")}
    >
      <div className="flex items-start justify-between gap-3">
        <span
          className="flex h-12 w-12 items-center justify-center"
          style={{
            background: "#ffffff",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-md)",
          }}
        >
          <PlayGlyph size={22} />
        </span>
        <span
          className="px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider"
          style={{ background: "var(--badge-bg)", color: "var(--text-muted)", borderRadius: 999 }}
        >
          Google Play
        </span>
      </div>

      <h3 className="font-heading mt-5 text-base font-bold text-navy">
        Dhamaan App-Yada aan dhisne
      </h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed" style={{ color: "var(--text-muted)" }}>
        180+ app oo aan dhisnay — booqo Play Store account developer-ka Daato.
      </p>

      <span
        className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold"
        style={{ color: "var(--accent)" }}
      >
        Arag dhammaan
        <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </span>
    </motion.a>
  );
}

export default function HomeProjects() {
  return (
    <section id="projects" className="py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.4 }}
          className="mx-auto max-w-2xl text-center"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-muted">
            Mashaariicdeena
          </span>
          <h2
            className="font-heading mt-4 text-navy"
            style={{ fontSize: "clamp(1.5rem, 2.8vw, 2rem)", fontWeight: 800, letterSpacing: "-0.03em" }}
          >
            Waxaan dhisnay
          </h2>
          <p className="mt-4 text-base" style={{ color: "var(--text-muted)" }}>
            Qeyb ka mid ah 180+ app oo aan dhisnay.
          </p>
        </motion.div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {projects.map((project, i) => (
            <ProjectCard key={project.name} project={project} index={i} />
          ))}
          {/* Final card: only ~20 of 180+ apps are listed, so hand people to
              the Play Store developer page rather than implying this is all. */}
          <SeeAllCard index={projects.length} />
        </div>

      </div>
    </section>
  );
}
